export const masterDataKeys = {
  all: ['master-data'],
  userOptions: (params) => ['master-data', 'user-options', params],
  diseases: (params) => ['master-data', 'diseases', params],
  superAdminDiseases: (params) => [
    'master-data',
    'super-admin-diseases',
    params,
  ],
  // Infinite-query variant (SA-2095). Its cache holds `{ pages, pageParams }`,
  // so it must never share a key with the regular `superAdminDiseases` query.
  superAdminDiseasesPaged: (params) => [
    'master-data',
    'super-admin-diseases',
    'paged',
    params,
  ],
  procedures: (params) => ['master-data', 'procedures', params],
  doctors: (params) => ['master-data', 'doctors', params],
  organizations: (params) => ['master-data', 'organizations', params],
  serviceClasses: (params) => ['master-data', 'service-classes', params],
  roleOptions: (params) => ['master-data', 'role-options', params],
  surgicalPhases: () => ['master-data', 'surgical-phases'],
  insuranceProviders: (params) => [
    'master-data',
    'insurance-providers',
    params,
  ],
  insuranceTypes: (params) => ['master-data', 'insurance-types', params],
  admissionTypes: (params) => ['master-data', 'admission-types', params],
  countries: (params) => ['master-data', 'countries', params],
  provinces: (params) => ['master-data', 'provinces', params],
  cities: (params) => ['master-data', 'cities', params],
  claimTypes: (params) => ['master-data', 'claim-types', params],
  currencies: (params) => ['master-data', 'currencies', params],
  categories: (params) => ['master-data', 'categories', params],
  insuranceCategories: (params) => [
    'master-data',
    'insurance-categories',
    params,
  ],
  doctorsSearchByName: (params) => [
    'master-data',
    'doctors-search-by-name',
    params,
  ],
  genders: (params) => ['master-data', 'genders', params],
  items: (params) => ['master-data', 'items', params],
  natureOperations: (params) => ['master-data', 'nature-operations', params],
  shareCurrencies: (params) => ['master-data', 'share-currencies', params],
  tpaOptions: (params) => ['master-data', 'tpa-options', params],
};

export const masterDataStaleTime = {
  TREND: 15 * 60 * 1000,
  BATCH: 10 * 60 * 1000,
  PAGED: 5 * 60 * 1000,
};
